"use client";
import React from "react";
import Screen from "../../components/Screen";
import ProfileHeaderSection from "../../components/ProfileHeaderSection";
import HeaderDescription from "../../components/HeaderDescription";
import HeaderBox from "../../components/Box/HeaderBox";
import { BackButton } from "../../components/forms/DashboardButton";
import { useNavigate } from "react-router-dom";

const Benefits = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/how-to-work/employee-manual");
  };

  return (
    <div className="bg-white w-full">
      <Screen>
        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Our Team"}
          subsubtext={"Benefit"}
        />
        <p className={` text-4xl text-lightDark my-4`}>Employee Benefits:</p>
        <div className="">
          <HeaderBox text="Revolutionizing African healthcare through technology" />
        </div>

        <div className="flex flex-col gap-5 mt-5">
          <div>
            <h2 className="font-semibold text-xl">1. Housing Assistance:</h2>
            <p>
              Funds to help you settle down in a new city and begin your
              LifeBank journey.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-xl">2. Health Insurance:</h2>
            <p>
              Health coverage for you and your loved ones under an accredited
              health insurance provider.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-xl">
              3. Focused Caring Team Members:
            </h2>
            <p>
              Team members dedicated to making you feel welcome and helping you
              do your best work.
            </p>
          </div>
          <div>
            <h2 className="font-semibold text-xl"> 4. Life Insurance:</h2>
            <p>
              A life insurance package to provide for your loved ones in case of
              any eventuality.
            </p>
          </div>
          <div>
            <h2 className="font-semibold text-xl"> 5. Accelerated Growth:</h2>
            <p>
              Support for taking on more responsibility, switching roles, or
              transitioning into a leadership position.
            </p>
          </div>
        </div>

        <div className="my-4 flex justify-end absolute bottom-2 right-3">
          <BackButton
            text={"Previous"}
            onClick={handleNext}
            subText={"Employee Manual"}
          />
        </div>
      </Screen>
    </div>
  );
};

export default Benefits;
